import axios from "axios";
import api from "../services/api";
import { stringToHTML } from "../utils/to-html";
import { $Q } from '../utils/query-selector';
import initBestSellerSlider from "./best-sellers";
import { btnShowVariants } from "./product.modal";
import { btnAddToCart } from "./cart";
import { variantOnChange } from "../components/variants-product";
import { priceVat } from "../components/price-vat";

/**
 * Returns the handles of the top sales products in the form of a string
 * @returns string
 */
const getBestSellers = async () => {
  const limitNumber = $Q('#best-sellers-service')
    ? Number($Q('#best-sellers-service').dataset.limitNumber)
    : 10;
  const currentDate = new Date().getTime();
  const endDate = new Date(currentDate).toISOString();
  const startDate = new Date(currentDate - (86400000 * 30)).toISOString();

  const rawTags = window.bestSellersNoTagged || "";
  const tagsParam = rawTags !== '' ? `&tags=${rawTags}` : '';

  const APIURL = `https://centrale-fillers-app.herokuapp.com/get_best_sellers?startDate=${startDate}&endDate=${endDate}&limitNumber=${limitNumber}${tagsParam}`;

  try {    
    const {
      data: { response }
    } = await axios.get(APIURL);
    
    return response.toString();
  } catch (error) {
    console.error(error);
    
    return [];
  }
}

/**
 * We render the section with the handles of the products obtained
 */
const renderBestSellers = async () => {
  const sectionToRender = $Q('#best-sellers-service .best-sellers');

  if (!sectionToRender) {
    return;
  }

  const lstHandles = await getBestSellers();
  const section = await api
    .renderShopifySection('best-sellers-rendering', `&lst_handles=${lstHandles}`);
  const content = $Q('#shopify-section-best-sellers-rendering .best-sellers', stringToHTML(section['best-sellers-rendering']));

  content.dataset.sectionId = sectionToRender.dataset.sectionId;
  sectionToRender.outerHTML = content.outerHTML;
  initBestSellerSlider();
  priceVat();
  btnAddToCart('.best-sellers__section .add-product-cart');
  btnAddToCart(".best-sellers__section .add-product-cart-upsell");
  btnShowVariants('.best-sellers__section .btn-show-variants-js');
  variantOnChange('.best-sellers__section .variants');
  const element = document.getElementsByClassName("trustpilot-widget");
  for (let i = 0; i < element.length; i++) {
    window.Trustpilot.loadFromElement(element[i]);
  }
}

renderBestSellers();
